import { AccessToken, ApiRole, Auth, Tokens, UserInfo } from 'ordercloud-javascript-sdk';
import { clearProductList } from '../ocProductList';
import { createOcAsyncThunk, OcThrottle } from '../ocReduxHelpers';
import { clearUser, getUser, updateUser } from '../ocUser';
import { clearCurrentOrder } from '../ocCurrentOrder';
import { cleanProductCache } from '../ocProductCache';
import { resetWishlistData } from '../wishlist';
import { sendMessageToFlutter } from 'src/hooks/useWebViewBridge';
import { CONSTANT, storageKeys } from 'src/helpers/mobileConstants';

const logoutThrottle: OcThrottle = {
  location: 'ocAuth',
  property: 'loading',
};

const logout = createOcAsyncThunk<AccessToken | undefined, { isManualLogout?: boolean } | void>(
  'ocAuth/logout',
  async (arg, thunkAPI) => {
    const { isManualLogout = false } = arg || {};
    const { ocConfig } = thunkAPI.getState();
    if (!ocConfig?.value) {
      throw new Error('OrderCloud Provider was not properly configured');
    }

    const isFlutterWebView = localStorage.getItem(storageKeys.IS_FLUTTER_WEB_VIEW);
    const user = thunkAPI.getState().ocUser.user;
    if (
      isFlutterWebView &&
      user?.xp &&
      user?.xp.FireBaseToken &&
      user?.xp.FireBaseToken?.length > 0
    ) {
      await thunkAPI.dispatch(updateUser({ ID: user?.ID, xp: { FireBaseToken: null } }));
    }
    thunkAPI.dispatch(resetWishlistData());
    thunkAPI.dispatch(clearUser());
    thunkAPI.dispatch(clearProductList());
    thunkAPI.dispatch(cleanProductCache());
    thunkAPI.dispatch(clearCurrentOrder());

    Tokens.RemoveAccessToken();
    Tokens.RemoveRefreshToken();
    if (!isManualLogout) {
      sendMessageToFlutter({
        action: CONSTANT.userSessionExpired,
        data: {
          isAnonymous: true,
        },
      });
      localStorage.setItem(
        storageKeys.IS_SESSION_EXPIRED,
        JSON.stringify({ isSessionExpired: true })
      );
    }

    const response = await Auth.Anonymous(
      ocConfig?.value.clientId,
      ocConfig?.value.scope as ApiRole[]
    );
    Tokens.SetAccessToken(response.access_token);
    Tokens.SetRefreshToken(response.refresh_token);

    const { identity_token } = await UserInfo.GetToken();
    Tokens.SetIdentityToken(identity_token);

    thunkAPI.dispatch(getUser());
    return response;
  },
  logoutThrottle
);

export default logout;
